<template>
  <div class="day">
      <div class="dayBox">
         <!-- 帮助按钮 -->
          <div class="rule"><img @click.stop="lookRule()" src="../../assets/img/daily/rule.png" alt=""></div>
          <div class='bgBox'>
            <!-- 背景图 -->
            <div class="picbox">
              <img  v-for="(item,index) in bgList" :key="index" class="bg" :src="item.url" alt="">
            </div>
          </div>
          <!-- 按钮 -->
          <div class="btnBox">
            <div v-show="star==1" class="btn" @touchstart="receive()">领取免费VIP</div>
            <div v-show="star==2" class="btn1">库存不足，耐心等待</div>
            <div v-show="star==3" class="btn2">您的兑换码 {{new_num}}</div>
          </div>
          <!-- 帮助 -->
          <div class="helpBox" v-show="rlueShow == true"  @click.stop="rlueCro()">
            <div class="help">
              <div class='help1'>
                <div class='title'>使用说明</div>
                <p>1、前往应用中心或AppStore下载产品“天天练“</p>
                <p>2、按照下图步骤激活天天练7天VIP体验码</p>
                <img class="mt12" src="../../assets/img/daily/t1.png" alt="">
                <img src="../../assets/img/daily/t2.png" alt="">
                <img src="../../assets/img/daily/t3.png" alt="">
              </div>
            </div>
          </div>
          <!-- 领取弹窗 -->
          <div class="receiveBox" v-show="copyShow == true">
            <div class="receive">
              <img src="../../assets/img/daily/tctitle.png" alt="">
              <div class="txt">天天练7天VIP体验码</div>
              <div class="num">{{new_num}}<button   class="copy" :data-clipboard-text='number' @click="copy">复制</button ></div>
              <div class='close'  @click.stop="copyCro()">确认</div>
            </div>
          </div>
         
      </div>
     
  </div>

  
</template>

<script>
import { Toast } from 'mint-ui';
import { setTimeout, setInterval, clearInterval } from 'timers';
import md5 from 'js-md5';
import axios from 'axios';
import Clipboard  from 'clipboard';
export default {
  name: 'day',
  data:function(){
    return{
       bgList:[
          {url:require('../../assets/img/daily/bg1.jpg')},
          {url:require('../../assets/img/daily/bg2.jpg')},
          {url:require('../../assets/img/daily/bg3.jpg')},
          {url:require('../../assets/img/daily/bg4.jpg')},
          {url:require('../../assets/img/daily/bg5.jpg')},
          {url:require('../../assets/img/daily/bg6.jpg')},
          {url:require('../../assets/img/daily/bg7.jpg')},
          {url:require('../../assets/img/daily/bg8.jpg')},
       ],
       number:'11',
       new_num:'',
       //频率id
       channelId:'',
       //来源
        type:'',
        typeId:'',
       rlueShow:false,
       copyShow:false,
       from1:'',
       star:'',
       //是否登录1是0否
       isLogin:'',
       //是否领取1是0否
       isReceive:'',
       //库存是否不足1是0否
       stockLess:'',
        isToken:'',
        isSalt:'',
        types:'',
    }
  },
   created(){
    var self=this;
    document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideOptionMenu');
    });

    this.typeId = this.$route.query.typeId;
    this.from1 = this.$route.query.from1;
    this.types = this.$route.query.livetype
    if(this.from1 == 'app'){
      console.log(this.from1 == 'app')
        this.getTitle();
        this.channelId = this.$route.query.channelId;
        this.type = this.$route.query.type;
        window['onWebResponse']=(str)=>{
            self.onWebResponse(str)
        }
    
    }else{
        this.channelId = this.cbct.getCookie('channel_id')
        if(this.$route.query.livetype==0){
           this.type = 'play'
        }
        if(this.$route.query.livetype==1){
           this.type = 'live'
        }
        this.isApp()
    }
    $('title').html('天天练福利派送');

    
  },
  methods:{
   
    isApp(){
      var self=this;
      axios.defaults.headers = {
        'Content-Type':'application/x-www-form-urlencoded',
      };
      axios.post(this.cbct.https()+'/admin/time', {  
      })
      .then(function (response) {
          if(response.data.c == self.cbct.code.successRes){
              var timing = response.data.d.time - Date.parse(new Date());                
              self.cbct.setCookie('timing',timing);        
                self.getData();
          } 
      })
      .catch(function (error) {
        
      });  
    },
      // 嵌入app获取用户登陆状态
        onWebResponse:function(str) {
            var obj=JSON.parse(str);
            var action=obj.action;
            var self=this;
            var content=obj.content;
            if (action=='setUserInfo') {
                self.isToken=content.token;
                self.isSalt=content.salt;
                if (self.isToken=='') {
                    self.cbct.setCookie('token','TOKEN');       
                }else{
                  self.cbct.setCookie('token',self.isToken);
                  
                }
                if (self.isSalt=='') {
                    self.cbct.setCookie('salt','SALT'); 
                }else{
                  self.cbct.setCookie('salt',self.isSalt);
                }         
                self.isApp()
            }
        },
     //给安卓传title的方法
        getTitle:function(){
            var self=this;
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            var obj={
                    "action": "setTitle",
                    "content": {
                        'title':'天天练福利派送',
                    }
                }
                if (isAndroid){
                    App.onAppResponse(JSON.stringify(obj));
                }
        },
      //兑换领取信息
      getData(){
          var self = this;

          self.http.post(self.cbct.https()+'/h5/leleschool-receive-info', self.qs.stringify({
          })).then((response)=>{
              if(response.c == self.cbct.code.successRes){  
                  self.isLogin = response.d.is_login
                  if(response.d.is_login==0){
                       self.star=1
                  }else{
                    if(response.d.is_receive==1){
                      self.star=3
                      self.number = response.d.code
                      self.new_num=this.number.replace(/\s/g,'').replace(/(.{4})/g,"$1 ");
                    }else{
                      if(response.d.stock_less==0){
                        self.star=1
                      }else{
                        self.star=2
                      }
                    }
                  }
              }else if(response.c == self.cbct.code.noLogin){
                  Toast({
                      message: response.m,
                      position: 'center',
                      duration: 1000
                  });
                  timing.time();
              }else if(response.c == self.cbct.code.raleNoLogin){              
              }else if(response.c == self.cbct.code.serviceError){
              }else{
                  Toast({
                      message: response.m,
                      position: 'center',
                      duration: 1000
                  });
              }
              
          }
          ).catch((error)=>{console.log(error);})
      },
    //规则弹窗
    lookRule:function(){
        this.rlueShow = true;
        $('html').css('position','fixed');
        $('html').css('top','0');
        $('html').css('bottom','0');
    },
    //关闭弹窗
    rlueCro(){
        this.rlueShow = false;
        $('html').css('position','static');
         this.$nextTick(() => {
          document.querySelector(".help1").scrollTop = '0px';
        });
    },
    //关闭弹窗
    copyCro(){
      this.copyShow = false;
      $('html').css('position','static');
    },
    //领取二维码
    receive(){
      var self = this;
       if(self.isLogin==0){
        if(self.from1=='app'){
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            const win = window;
            var obj={
                "action": "goToLogin",
                "content": {
                }
            }
            if(isAndroid){
                if(self.cbct.getCookie('token')=='TOKEN'){
                    App.onAppResponse(JSON.stringify(obj));
                }
            }
            if(isIOS){
                if (self.cbct.getCookie('token')=='TOKEN') {
                    win.webkit.messageHandlers.onAppResponse.postMessage(JSON.stringify(obj));
                }
            }  
        }else{
            var ua = navigator.userAgent.toLowerCase();
            var isWeixin = ua.indexOf('micromessenger') != -1;
            if (!isWeixin) {
              Toast({
                    message: '请下载听见广播app参加此活动',
                    position: 'center',
                    duration: 3000
                });
            }else {
              setTimeout(() => {
                  self.$router.push({path:'./register?returnUrl=day?type=live&channelId='+self.channelId+'&a=1'});
              },1000)  
            }
        }
      }else{
  
        self.http.post(self.cbct.https()+'/h5/leleschool-receive', self.qs.stringify({
            type:self.type,
            typeId:self.typeId,
            channelId:self.channelId,
        })).then((response)=>{
          if(response.c == self.cbct.code.successRes){ 
            self.copyShow=true
            self.star=3
            self.number = response.d.code
            self.new_num=this.number.replace(/\s/g,'').replace(/(.{4})/g,"$1 ");
          }else{
              Toast({
              message: response.m,
              position: 'center',
              duration: 3000
          });
          }
        }
        ).catch((error)=>{console.log(error);})
        }
      
    },
    //复制
    copy() {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        Toast({
              message: '复制成功',
              position: 'center',
              duration: 3000
          });
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
         Toast({
              message: '不支持自动复制',
              position: 'center',
              duration: 3000
          });
        console.log('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
      }
  },
 
  mounted(){
    
   
  },
  components: {
  
  },
 
}


</script>
<style scoped lang="scss">  
  .day{
      width: 100%;
      line-height: 0 !important;
      display: flex;
      flex-direction: column; 
      height: 100vh;
      box-sizing: border-box;
      overflow: hidden;
      .dayBox{
        width: 100%;
        height: 100vh;
        box-sizing: border-box;
        line-height: 0 !important;
        position: relative;
        display: flex;
        flex-direction: column; 
        z-index: 1;
        .helpBox{
          position: absolute;
          top:0;
          left:0;
          z-index: 89;
          background:rgba(0,0,0,0.5);
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          .help{
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            height:6.48rem ;
            background:rgba(255,255,255,1);
            border-radius:.28rem .28rem 0px 0px;
            box-sizing: border-box;
            padding-top: .28rem;
            overflow:hidden;
            -webkit-overflow-scrolling: touch;
            .help1{
              width: 6.86rem;
              margin: 0 auto;
              height:6.48rem ;
              padding-bottom: .5rem;
              box-sizing: border-box;
              overflow-y:scroll;
              -webkit-overflow-scrolling: touch;
              .title{
                font-size: .3rem;
                color:rgba(0,0,0,0.7);
                margin: .2rem auto .3rem;
                font-weight: 500;
                line-height: .42rem;
              }
              p{
                font-size: .3rem;
                color:rgba(0,0,0,0.8);
                line-height:.56rem;
                text-align: left;
              }
              .mt12{
                margin-top: .12rem;
              }
              img{
                width: 100%;
              }
            }
            ::-webkit-scrollbar{display: none;}
          }
        }
        .rule{
          position:fixed;
          top: .3rem;
          right:.24rem;
          z-index: 88;
          img{
            width:.1.76rem;
            height: .52rem;
          }
        }
        .bgBox{
          width: 100%;
         
          z-index: 1;
          overflow:hidden;
          -webkit-overflow-scrolling: touch;
          flex: 1;
          box-sizing: border-box;
          overflow: hidden;
          .picbox{
            width: 100%;
            height: 100vh;
            padding-bottom: 1.2rem;
            box-sizing: border-box;
            overflow-y:scroll;
            -webkit-overflow-scrolling: touch;
            .bg{
              display: block;
              width: 100%;
              height: auto;
              border: 0;
              margin: 0;
            }
          }
        } 
        .receiveBox{
          position: fixed;
          top:0;
          left:0;
          background:rgba(0,0,0,0.5);
          width: 100%;
          height: 100%;
          overflow: hidden;
          box-sizing: border-box;
          z-index: 89;
          .receive{
            width: 5.4rem;
            height: 5.5rem;
            background:rgba(255,255,255,1);
            border-radius:.16rem;
            margin: 30% auto 0;
            justify-content: center;
            overflow: hidden;
            box-sizing: border-box;
            img{
              width: 100%;
              height: 2.3rem;
              margin-bottom: .34rem;
            }
            .txt{
              font-size: .28rem;
              color:rgba(0,0,0,0.7);
              text-align: left;
              height: .7rem;
              margin-left:.36rem;
              line-height: .7rem;
              box-sizing: border-box;
            }
            .num{
              font-size:.4rem;
              color:rgba(0,0,0,0.7);
              height: .7rem;
              margin-left: .36rem;
              line-height: .7rem;
              text-align: left;
              box-sizing: border-box;
              overflow: hidden;
              .copy{
                display: inline-block;
                width: .91rem;
                height: .42rem;
                opacity:0.45;
                border:1px solid rgba(0,0,0,0.16);
                border-radius:.08rem;
                text-align: center;
                line-height: .42rem;
                font-size: .24rem;
                color: #000;
                float: right;
                box-sizing: border-box;
                margin-right: .36rem;
                margin-top:.12rem ;
                padding: 0;
              }
            }
            .close{
              width:4.68rem;
              height:.72rem;
              background:rgba(255,50,62,1);
              border-radius:.08rem;
              margin: 0 auto;
              font-size:.28rem ;
              line-height: .72rem;
              color: #fff;
              box-sizing: border-box;
              margin-top: .28rem;
            }
          }
        }
        .btnBox{
          // position: fixed;
          // left: 0;
          // bottom: 0;
          width: 100%;
          height:1.2rem;
          z-index: 88;
          background:rgba(255,255,255,1);
          .btn{
            width:7rem;
            height: .8rem;
            background:#FF323E;
            border-radius:0.16rem;
            font-size: .3rem;
            color: #fff;
            line-height: .8rem;
            text-align: center;
            margin: .2rem auto;
            box-sizing: border-box;
              z-index: 88;
          }
          .btn1{
            width:7rem;
            height: .8rem;
            background:#FF323E;
            border-radius:0.16rem;
            font-size: .3rem;
            color: #fff;
            line-height: .8rem;
            text-align: center;
            margin: .2rem auto;
            opacity:0.53;
            z-index: 88;
            box-sizing: border-box;
          }
            .btn2{
            width:7rem;
            height: .8rem;
            background:url('../../assets/img/daily/btn.png') no-repeat;
            background-size:100% 100%;
            border-radius:0.16rem;
            font-size: .3rem;
            color: #000;
            z-index: 88;
            line-height: .8rem;
            text-align: center;
            margin: .2rem auto;
            opacity:0.9;
            box-sizing: border-box;
          }
        }
       
      }
    
  }
 
</style>

